import { render, staticRenderFns } from "./pubbrand.vue?vue&type=template&id=322e6bab&scoped=true&"
import script from "./pubbrand.vue?vue&type=script&lang=js&"
export * from "./pubbrand.vue?vue&type=script&lang=js&"
import style0 from "./pubbrand.vue?vue&type=style&index=0&id=322e6bab&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322e6bab",
  null
  
)

export default component.exports